import { useEffect, useState } from "react";
import { AccessControlAPI, AccessSystemsAPI } from "../../api/accessControl";

export default function AccessAddTokenPage() {
  const [systems, setSystems] = useState([]);
  const [form, setForm] = useState({
    systemId: "",
    schoolId: "",
    email: "",
    tokenNumber: "",
    tokenType: "fob",
  });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function loadSystems() {
    try {
      const data = await AccessSystemsAPI.list();
      const enabledSystems = Array.isArray(data)
        ? data.filter((system) => system.enabled)
        : [];

      setSystems(enabledSystems);
    } catch (err) {
      console.error("Failed to load Net2 systems", err);
      setError("Failed to load Net2 systems");
    }
  }

  useEffect(() => {
    loadSystems();
  }, []);

  function handleSystemChange(systemId) {
    const selected = systems.find((system) => String(system.id) === systemId);

    setForm({
      ...form,
      systemId,
      schoolId: selected ? selected.school_id : "",
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    setSaving(true);
    setMessage("");
    setError("");

    try {
      const job = await AccessControlAPI.addToken({
        systemId: Number(form.systemId),
        schoolId: Number(form.schoolId),
        email: form.email.trim(),
        tokenNumber: form.tokenNumber.trim(),
        tokenType: form.tokenType,
      });

      setMessage(`Job ${job.id} created with status: ${job.status}`);
      setForm({
        systemId: "",
        schoolId: "",
        email: "",
        tokenNumber: "",
        tokenType: "fob",
      });
    } catch (err) {
      console.error("Failed to create AddToken job", err);
      setError("Failed to create AddToken job");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Add Token to Net2 User</h1>
        <p className="text-sm text-gray-600">
          Creates a job to add a fob/card token to an existing Net2 user.
        </p>
      </div>

      {message && (
        <div className="rounded border border-green-300 bg-green-50 p-3 text-sm text-green-700">
          {message}
        </div>
      )}

      {error && (
        <div className="rounded border border-red-300 bg-red-50 p-3 text-sm text-red-700">
          {error}
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        className="max-w-xl rounded border bg-white p-4 space-y-4"
      >
        <div>
          <label className="block text-sm font-medium mb-1">Net2 System</label>
          <select
            value={form.systemId}
            onChange={(e) => handleSystemChange(e.target.value)}
            className="w-full rounded border p-2"
            required
          >
            <option value="">Select Net2 system</option>
            {systems.map((system) => (
              <option key={system.id} value={system.id}>
                {system.school_name} — {system.system_name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">User Email</label>
          <input
            type="email"
            value={form.email}
            onChange={(e) =>
              setForm({ ...form, email: e.target.value })
            }
            className="w-full rounded border p-2"
            placeholder="person@school.org"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Token Number</label>
          <input
            type="text"
            value={form.tokenNumber}
            onChange={(e) =>
              setForm({ ...form, tokenNumber: e.target.value })
            }
            className="w-full rounded border p-2"
            placeholder="123456789"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Token Type</label>
          <select
            value={form.tokenType}
            onChange={(e) =>
              setForm({ ...form, tokenType: e.target.value })
            }
            className="w-full rounded border p-2"
          >
            <option value="fob">Fob</option>
            <option value="card">Card</option>
          </select>
        </div>

        <button
          type="submit"
          disabled={saving}
          className="rounded bg-blue-600 px-4 py-2 text-white disabled:opacity-60"
        >
          {saving ? "Creating..." : "Create Add Token Job"}
        </button>
      </form>
    </div>
  );
}